import { DISPLAY_TZ } from "./tz";
import type { Timeframe } from "@alpha/shared";

/** Offset of the display time zone from UTC at a given instant, in seconds (Africa/Johannesburg is +7200, no DST). */
export function tzOffsetSeconds(unixSec: number, tz: string = DISPLAY_TZ): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz, hourCycle: "h23", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric",
  }).formatToParts(new Date(unixSec * 1000));
  const get = (t: string) => Number(parts.find((p) => p.type === t)?.value);
  const asUtc = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second"));
  return Math.round(asUtc / 1000 - unixSec);
}

/**
 * Chart time for a UTC instant. Daily bars are calendar dates (the UTC date of the bar).
 * Intraday bars are shifted so the chart axis, which draws timestamps as UTC, reads Africa/Johannesburg time.
 */
export function toChartTime(unixSec: number, tf: Timeframe): string | number {
  if (tf === "1d") return new Date(unixSec * 1000).toISOString().slice(0, 10);
  return unixSec + tzOffsetSeconds(unixSec);
}
